export default "__VITE_ASSET__DDx0m2uv__"